module.exports = __webpack_public_path__ + "static/media/Event2.8160fac1.jpg";